import { ChevronRightIcon } from 'lucide-react';
import { Dialog, DialogContent, DialogTrigger } from '../atoms/Dialog';
import { ResetPasswordContainer } from '@/containers/auth/reset-password-container';
import { useState } from 'react';
import { useToast } from '@/hooks/V3/useToast';

export const PasswordDialog = () => {
  const [open, setOpen] = useState(false);
  const { showToast } = useToast();

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger className="flex w-full items-center justify-between text-gr-700 Body2M16">
        <span className="text-gr-700 Body2M16">비밀번호</span>
        <ChevronRightIcon className="h-5 w-5 text-gr-400" />
      </DialogTrigger>
      <DialogContent className="w-[400px]" noCloseBtn>
        <div className="space-y-1">
          <div className="text-gr-900 Title3S18">비밀번호 재설정</div>
          <div className="text-gr-700 Body5M14">
            비밀번호 재설정을 위해 가입에 사용한
            <br />
            휴대폰 번호를 입력해 주세요
          </div>
        </div>
        <ResetPasswordContainer
          isMypage
          onCompleted={() => {
            setOpen(false);
            showToast('success', '비밀번호 재설정이 완료되었어요');
          }}
          onCanceled={() => {
            setOpen(false);
          }}
        />
      </DialogContent>
    </Dialog>
  );
};
